import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}providers`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}providers/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}providers`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}providers/${id}`)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}providers/${id}`, data)
  },
  checkCnpjExists (cnpj) {
    return Vue.http.post(`${API_URL}providers/cnpj/`, {cnpj: cnpj})
  },
  checkCpfExists (cpf) {
    return Vue.http.post(`${API_URL}providers/cpf/`, {cpf: cpf})
  }
}



// WEBPACK FOOTER //
// ./src/services/provider.js